module.exports = __webpack_public_path__ + "img/noelle.532f7913.webp";